import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Brain } from 'lucide-react';
import { StreamdownMessage } from '../ai/StreamdownMessage';

interface ReasoningProps {
  text: string;
  isStreaming?: boolean;
  defaultExpanded?: boolean;
}

export function Reasoning({
  text,
  isStreaming = false,
  defaultExpanded = false,
}: ReasoningProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded || isStreaming);

  const toggleExpanded = () => {
    if (!isStreaming) {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <div className="my-2 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <button
        onClick={toggleExpanded}
        className={`w-full flex items-center gap-2 px-3 py-2 bg-gray-50 dark:bg-gray-800/50 hover:bg-gray-100 dark:hover:bg-gray-800
          transition-colors text-left ${isStreaming ? 'cursor-default' : 'cursor-pointer'}`}
        disabled={isStreaming}
      >
        <Brain className="w-4 h-4 text-amber-500" />
        <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
          Reasoning
          {isStreaming && <span className="ml-2 text-amber-500">...</span>}
        </span>
        <div className="ml-auto">
          {isExpanded ? (
            <ChevronDown className="w-4 h-4 text-gray-400" />
          ) : (
            <ChevronRight className="w-4 h-4 text-gray-400" />
          )}
        </div>
      </button>

      {isExpanded && (
        <div className="px-3 py-2 bg-white dark:bg-gray-900">
          <div className="text-sm text-gray-600 dark:text-gray-300 italic">
            <StreamdownMessage content={text} isStreaming={isStreaming} />
            {isStreaming && (
              <span className="inline-block w-1.5 h-3 bg-amber-400 animate-pulse ml-0.5" />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
